import React from 'react';

export const PASSWORD_RULES = [
  { test: v => v.length >= 8,    label: 'Minimum 8 characters' },
  { test: v => /[A-Z]/.test(v),  label: 'At least one uppercase letter' },
  { test: v => /[0-9]/.test(v),  label: 'At least one number' },
];

/**
 * Élő jelszó-ellenőrző lista + erősségsáv.
 * Csak akkor jelenik meg, ha a user már gépelt valamit.
 */
export default function PasswordRules({ value = '' }) {
  if (!value) return null;

  const results = PASSWORD_RULES.map(r => ({ ...r, ok: r.test(value) }));
  const passed = results.filter(r => r.ok).length;

  const barTone =
    passed === 3 ? 'bg-emerald-400' : passed === 2 ? 'bg-amber-400' : 'bg-red-400';

  return (
    <div className="mt-3">
      <div className="flex gap-1.5 mb-2.5">
        {PASSWORD_RULES.map((_, i) => (
          <span
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors duration-300 ${
              i < passed ? barTone : 'bg-white/[0.08]'
            }`}
          />
        ))}
      </div>

      <div className="space-y-1.5">
        {results.map(r => (
          <div
            key={r.label}
            className={`flex items-center gap-2 text-xs transition-colors duration-200 ${
              r.ok ? 'text-emerald-400' : 'text-gray-600'
            }`}
          >
            {r.ok ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"
                   strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3 flex-shrink-0">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            ) : (
              <span className="w-3 h-3 flex-shrink-0 flex items-center justify-center">
                <span className="w-1.5 h-1.5 rounded-full border border-current" />
              </span>
            )}
            {r.label}
          </div>
        ))}
      </div>
    </div>
  );
}
